var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExpandCollapse = function SvgExpandCollapse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 22",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.794 18.085a1.002 1.002 0 00-1.402-.186L9 18.967v-1.973a1 1 0 10-2 0v1.973L5.608 17.9a1.001 1.001 0 00-1.216 1.588l3 2.301c.043.033.094.05.14.075.039.021.072.044.112.06a.98.98 0 00.356.071.98.98 0 00.356-.072c.04-.015.073-.038.11-.059.048-.025.099-.042.142-.075l3-2.3a1 1 0 00.186-1.403zm-.186-15.584l-3-2.3c-.043-.033-.093-.05-.14-.075-.038-.021-.072-.044-.113-.06a.99.99 0 00-.71 0c-.04.016-.076.039-.114.06-.047.025-.097.042-.14.075l-3 2.3a1 1 0 001.217 1.587L7 3.021v1.973a1 1 0 102 0V3.021l1.391 1.067a1 1 0 101.217-1.587zM15 9.994H1a1 1 0 010-2h14a1 1 0 110 2zm0 4H1a1 1 0 110-2h14a1 1 0 110 2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpandCollapse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expand-collapse.67df4d1c.svg";
export { ForwardRef as ReactComponent };